import productApi from "../../apis/productApi";


async function getSkuFiledsDetails(params: any) {
    const baseUrl = `/product/sku/skuValue?product_id=${params.product_id}&sku_id=${params.sku_id}`;
    const data = await productApi.get(`${baseUrl}`);
    return data
}

export { getSkuFiledsDetails }